import React from "react";
import Icon from "components/AppIcon";

const TRUST_ITEMS = [
  {
    icon: "ShieldCheck",
    label: "SSL Secured",
    description: "256-bit encryption",
    color: "text-success",
  },
  {
    icon: "BadgeCheck",
    label: "Certified Org",
    description: "Nationally accredited",
    color: "text-primary",
  },
  {
    icon: "Lock",
    label: "Privacy Protected",
    description: "Data never shared",
    color: "text-accent",
  },
];

export default function TrustSignals() {
  return (
    <div className="mt-6 pt-5 border-t border-border">
      <p className="font-caption text-xs text-muted-foreground text-center mb-3 uppercase tracking-wide">
        Your information is safe with us
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        {TRUST_ITEMS?.map((item) => (
          <div key={item?.label} className="flex items-center gap-2">
            <Icon name={item?.icon} size={16} color="currentColor" className={item?.color} />
            <div>
              <p className={`font-caption text-xs font-semibold ${item?.color}`}>{item?.label}</p>
              <p className="font-caption text-xs text-muted-foreground">{item?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}